import moment from 'moment-timezone'

export const getMomentDateMax = (timezone: string) => {
  return moment.tz(timezone).subtract(1, 'day')
}
